/**
 * Lexical Editor Theme Configuration
 * Maps Lexical node types to CSS classes for styling
 */

const EditorTheme = {
  // Root paragraph styling
  paragraph: 'editor-paragraph',
  
  // Text formatting classes
  text: {
    bold: 'editor-text-bold',
    italic: 'editor-text-italic',
    underline: 'editor-text-underline',
    strikethrough: 'editor-text-strikethrough',
    underlineStrikethrough: 'editor-text-underlineStrikethrough',
    code: 'editor-text-code',
  },
  
  // Heading styles
  heading: {
    h1: 'editor-heading-h1',
    h2: 'editor-heading-h2',
    h3: 'editor-heading-h3',
  },
  
  // List styles
  list: {
    ul: 'editor-list-ul',
    ol: 'editor-list-ol',
    listitem: 'editor-listitem',
    nested: {
      listitem: 'editor-nested-listitem',
    },
  },
  
  // Link styling
  link: 'editor-link',
  
  // Quote styling
  quote: 'editor-quote',
};

export default EditorTheme;
